import { z } from 'zod';
import '@apexdesigner/schema-tools';
import {
  belongsTo,
  hasMany,
  options,
  references,
} from '@apexdesigner/schema-tools';

export const supportCase = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    title: z.string().nullable().optional().requiredFinal().describe('Title'),

    description: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Description - Markdown content describing the issue'),

    status: options([
      { value: 'Draft', name: 'Draft' },
      { value: 'Open', name: 'Open' },
      { value: 'In Progress', name: 'In Progress' },
      { value: 'Resolved', name: 'Resolved' },
      { value: 'Closed', name: 'Closed' },
    ])
      .nullable()
      .optional()
      .describe('Status'),

    priority: options([
      { value: 'Low', name: 'Low' },
      { value: 'Medium', name: 'Medium' },
      { value: 'High', name: 'High' },
      { value: 'Critical', name: 'Critical' },
    ])
      .nullable()
      .optional()
      .describe('Priority'),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .disabled()
      .describe('createdAt'),

    createdBy: references('User'),

    createdById: z
      .number()
      .nullable()
      .optional()
      .disabled()
      .presentAs('reference')
      .describe('Foreign key to User'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .disabled()
      .describe('updatedAt'),

    updatedBy: references('User'),

    updatedById: z
      .number()
      .nullable()
      .optional()
      .disabled()
      .presentAs('reference')
      .describe('Foreign key to User'),

    accountId: z.number().hidden().describe('Foreign key to Account'),

    account: belongsTo('Account'),

    comments: hasMany('SupportComment', 'caseId'),

    attachments: hasMany('SupportAttachment', 'caseId'),
  })
  .describe('A support request submitted by a user within an account.')
  .as('SupportCase');

export { supportCase as supportCaseSchema };
